<link [href]="brandingCss" rel="stylesheet">

<div class="ifa-calc-wrapper" fxLayout="column" *ngIf="offerPageScreen === OfferPageScreen.FullOffer">

  <ifa-product-navigator *ngIf="navigator?.bestTermOfferBundle || navigator?.bestLawOfferBundle || (navigator?.bestLocOfferBundle && navigator?.bestLargeLoanProgramOfferBundle)" [offerNavigator]="navigator" [customerView]="customerView"></ifa-product-navigator>

  <ifa-repayment-navigator *ngIf="navigator?.currentLocOfferBundles?.length > 1" [offerBundles]="navigator?.currentLocOfferBundles" 
    [currentOfferBundle]="navigator?.currentOfferBundle" [customerView]="customerView"></ifa-repayment-navigator>

  <h4 class="layout padding-left padding-right">
    <ifa-calculator-heading [businessName]="bundle?.businessName"></ifa-calculator-heading>
  </h4>  

  <ifa-line-of-credit-content [offer]="offer" [customerView]="customerView"></ifa-line-of-credit-content>

</div>

<ifa-offer-page-status-message *ngIf="offerPageScreen && offerPageScreen !== OfferPageScreen.FullOffer"
                              [screen]="offerPageScreen"
                              [application]="application"></ifa-offer-page-status-message>
